<template functional>
  <div class="flex-r">
    <div class="section size-20" />

    <div class="section size-60 txt-algn-c">
      <h1>
        Для начала давайте выберем подходящий <span class="nowrap">для вас</span> тарифный план:
      </h1>

      <a class="button primary" href="/pricing">
        <span class="text">
          Подробнее о тарифных планах
        </span>
      </a>

      <a class="button" href="/about#sales">
        <span class="text">
          Возникли проблемы?
        </span>
      </a>

      <br><br><br><br><br><br><br>
    </div>

    <div class="section size-20" />
  </div>
</template>

<script>
export default {
  name: 'TheHeader'
}
</script>
